import React, { useState } from "react";
import "./App.css";
import logo from "./assets/logo.png";
import banner from "./assets/banner.jpg";

function App() {
  return (
    <div className="App">
      <Header />
      <MainContent />
      <Footer />
    </div>
  );
}

function Header() {
  return (
    <header className="App-header">
      <img src={logo} alt="Company Logo" className="logo" />
      <h1 className="company-title">Atemb</h1>
      <p className="company-slogan">Innovative Solutions for Embedded Systems</p>
      <nav>
        <a href="#services">Services</a>
        <a href="#contact">Contact</a>
      </nav>
    </header>
  );
}

function MainContent() {
  return (
    <main>
      <Hero />
      <Services />
      <Contact />
    </main>
  );
}

function Hero() {
  return (
    <section className="hero">
      <img src={banner} alt="Banner" className="banner-image" />
      <h1>Embedded Systems &amp; Test Automation for Firmware</h1>
      <p>Bright, innovative solutions tailored to your tech needs.</p>
    </section>
  );
}

function Services() {
  return (
    <section className="services" id="services">
      <h2>Our Services</h2>
      <div className="service-cards">
        <div className="service-card">
          <h3>Embedded Systems</h3>
          <p>
            We design and develop robust embedded systems that power your devices.
          </p>
        </div>
        <div className="service-card">
          <h3>Test Automation</h3>
          <p>
            Our test automation services ensure firmware quality and reliable performance.
          </p>
        </div>
      </div>
    </section>
  );
}

function Contact() {
  const [formData, setFormData] = useState({
    surname: "",
    name: "",
    email: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can integrate your API or email service here.
    console.log("Form submitted:", formData);
    setSubmitted(true);
    // Optionally, reset the form:
    setFormData({
      surname: "",
      name: "",
      email: "",
      message: "",
    });
  };

  return (
    <section className="contact" id="contact">
      <h2>Contact Us</h2>
      {submitted && (
        <p className="thank-you">
          Thank you for your message. We will get back to you soon!
        </p>
      )}
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="surname">Surname:</label>
          <input
            type="text"
            id="surname"
            name="surname"
            value={formData.surname}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="message">Message:</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <button type="submit">Send Message</button>
      </form>
    </section>
  );
}

function Footer() {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()} Atemb UG. All rights reserved.</p>
    </footer>
  );
}

export default App;
